<template>
  <div>
    <b-row class="px-2">
      <b-col class="px-1 mb-2">
        <datetime
          v-model="start_date"
          :config="dateConfig"
          :placeholder="trans('start')"
          class="form-control form-control-sm"
        ></datetime>
      </b-col>
      <b-col v-if="!all_day" class="px-1 mb-2">
        <b-form-select
          v-model="start_time"
          :options="startTimeOptions"
          size="sm"
        ></b-form-select>
      </b-col>
      <b-col v-if="!all_day" class="px-1 mb-2">
        <b-form-select
          v-model="end_time"
          :options="endTimeOptions"
          size="sm"
          :state="endIsBeforeStart ? false : null"
          @change="onChangeEndTime"
        ></b-form-select>
      </b-col>
      <b-col v-if="all_day || start_date != end_date || endIsBeforeStart" class="px-1 mb-2">
        <datetime
          v-model="end_date"
          :config="dateConfig"
          :placeholder="trans('end')"
          :class="`form-control form-control-sm ${endIsBeforeStart ? 'is-invalid' : ''}`"
        ></datetime>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-1">
        <b-form-checkbox v-model="all_day" switch size="sm">
          {{ trans('all_day') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import Datetime from 'vue-bootstrap-datetimepicker'

  export default {
    props: {
      organization: Object,
      start: String,
      end: String,
      allDay: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Datetime,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        start_date: moment(this.start).format('YYYY-MM-DD'),
        start_time: moment(this.start).format('HH:mm:ss'),
        end_date: moment(this.end).format('YYYY-MM-DD'),
        end_time: moment(this.end).format('HH:mm:ss'),
        all_day: this.allDay,
        dateConfig: {
          locale: window.lang,
          format: 'YYYY-MM-DD',
          showTodayButton: true,
        },
      }
    },
    computed: {
      serializedStart() {
        return moment(this.start_date + ' ' + this.start_time, 'YYYY-MM-DD HH:mm:ss').toISOString()
      },
      serializedEnd() {
        return moment(this.end_date + ' ' + this.end_time, 'YYYY-MM-DD HH:mm:ss').toISOString()
      },
      endIsBeforeStart() {
        if (this.all_day && this.start_date == this.end_date) return false
        return !moment(this.serializedStart).isBefore(this.serializedEnd)
      },
      serialized() {
        return {
          start: this.serializedStart,
          end: this.serializedEnd,
          allDay: this.all_day
        }
      },
      startTimeOptions() {
        let options = []
        let d = moment()
        for (let i = 0; i < 24; i++) {
          for (let m = 0; m < 60; m += 15) {
            let h = i + 6
            if (h >= 24) h -= 24
            d.set({
              hour: h,
              minute: m,
              second: 0
            })
            options.push({
              value: d.format('HH:mm:ss'),
              text: d.format('LT')
            })
          }
        }
        return options
      },
      endTimeOptions() {
        let start = moment(moment().format('YYYY-MM-DD') + ' ' + this.start_time, 'YYYY-MM-DD HH:mm:ss')
        let delta = Math.floor(start.diff(moment(start).startOf('day'), 'hours'))
        let options = []
        for (let i = 0; i < 24; i++) {
          for (let m = 0; m < 60; m += 15) {
            let h = i + delta
            let d = moment().startOf('day')
            d.add(h, 'hours')
            d.add(m, 'minutes')
            let minutes = d.diff(start, 'minutes')
            let hours = Math.round(100*minutes / 60)/100
            if (minutes > 0 && hours < 24) {
              options.push({
                value: d.format('HH:mm:ss'),
                text: `${d.format('LT')} (${minutes < 60 ? (minutes + 'm') : (hours + 'h')})`
              })
            }
          }
        }
        return options
      },
    },
    watch: {
      start() {
        this.start_date = moment(this.start).format('YYYY-MM-DD')
        this.start_time = moment(this.start).format('HH:mm:ss')
        if (!this.end || moment(this.end).isBefore(this.start)) {
          this.end_date = this.start_date
        }
      },
      end() {
        this.end_date = moment(this.end).format('YYYY-MM-DD')
        this.end_time = moment(this.end).format('HH:mm:ss')
      },
      allDay() {
        this.all_day = this.allDay
      },
      serialized() {
        if (this.start != this.serialized.start)
          this.$emit('start', this.serialized.start)
        if (this.end != this.serialized.end)
          this.$emit('end', this.serialized.end)
        if (this.allDay != this.serialized.allDay)
          this.$emit('all-day', this.serialized.allDay)
      },
    },
    methods: {
      onChangeEndTime() {
        this.$nextTick(() => {
          if (this.endIsBeforeStart) {
            this.end_date = moment(this.start_date).add(1, 'day').format('YYYY-MM-DD')
          }
        })
      },
    },
    mounted() {
      window.editEeventDate = this
    },
  }
</script>